import React, { useEffect, useRef, useState } from 'react';
import { Bell } from 'lucide-react';
import { api, DEMO } from '../lib/api';
import { hasCap } from '../lib/capabilities';
import { REQUEST_TYPES, URGENCY } from '../lib/clinicalMessages';
import './ClinicalMessages.css';

const KIND_LABELS = {
  new_request: 'New clinical request',
  new_message: 'New message',
  returned_for_correction: 'Returned for correction',
  info_received: 'Information received',
  certification_required: 'Certification required',
  assigned: 'Assigned to you',
  status_changed: 'Status changed',
};

export default function NotificationBell({ user, notify, navigate }) {
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const load = () => {
    if (DEMO || !hasCap(user, 'clinical_messages.view')) return;
    api('/clinical-message-notifications')
      .then(d => { setItems(d.notifications || []); setUnread(d.unread || 0); })
      .catch(() => {});
  };

  useEffect(() => { load(); const t = setInterval(load, 60000); return () => clearInterval(t); }, [user]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    const close = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, []);

  if (!hasCap(user, 'clinical_messages.view')) return null;

  async function openThread(n) {
    setOpen(false);
    if (n.read_at == null) { try { await api(`/clinical-message-notifications/${n.id}/read`, { method: 'POST', body: {} }); } catch (e) { notify(e.message); } load(); }
    navigate(`/messages/${n.thread_id}`);
  }

  return <div className="notification-bell" ref={ref}>
    <button className="icon-button" aria-label={`Notifications (${unread} unread)`} onClick={() => setOpen(o => !o)}><Bell size={18}/>{unread > 0 && <span className="bell-count">{unread > 99 ? '99+' : unread}</span>}</button>
    {open && <div className="notification-dropdown">
      <div className="nd-head">Clinical notifications</div>
      {items.length ? items.map(n => {
        const urg = URGENCY[n.urgency] || { label: n.urgency, tone: 'neutral' };
        return <button key={n.id} className={`notification-item ${n.read_at == null ? 'unread' : ''}`} onClick={() => openThread(n)}>
          <span className="nd-main">
            <strong>{KIND_LABELS[n.kind] || n.kind}</strong>
            <p>{n.subject || REQUEST_TYPES[n.request_type] || 'Clinical request'}{n.patient_name ? ` · ${n.patient_name}` : ''}{n.sender_name ? ` · ${n.sender_name}` : ''}</p>
            <small>{new Date(n.created_at).toLocaleString()}</small>
          </span>
          {n.urgency && n.urgency !== 'ROUTINE' && <span className={`cm-badge ${urg.tone}`}>{urg.label}</span>}
        </button>;
      }) : <div className="notification-empty">No notifications.</div>}
    </div>}
  </div>;
}
